define(function(require, exports, module) {
    'use strict';

    var config = require('config');

    module.exports = {

        getDynamicTags() {
            return config.get('dynamicTags') || {};
        },

        getDynamicTag(key) {
            let dTags = this.getDynamicTags();

            return dTags[`DTAG_${key}`] || '';
        },

        getDynamicTagList(key) {
            let value = this.getDynamicTag(key);

            return value ? value.split(',') : [];
        },

        getDynamicTagMap(key) {
            let map = {};
            let value = this.getDynamicTag(key);

            try {
                map = JSON.parse(value);
            } catch (e) {
                console.error(`parse error: could not parse value of ${key} tag`);
            }

            return map;
        }
    };
});
